import { handleError } from "cc-frontend/error-handling"

/**
 * Reports a failed save the user cannot see. These saves run from a timer, a blur handler, or a
 * microtask. Those stacks never reach Ember.onerror, so an unwrapped failure is silent.
 *
 * Do not wrap a save the user starts and watches, such as adding a comment. The global handler
 * still reports it, and the user can try again.
 *
 * Give an async `run` its own .catch. It type-checks here, but its rejection escapes the try.
 */
export function guardedSave<A extends unknown[]>(run: (...args: A) => void): (...args: A) => void {
  return (...args) => {
    try {
      run(...args)
    } catch (error) {
      handleError(error instanceof Error ? error : new Error(String(error)))
    }
  }
}
